export default __webpack_public_path__ + "static/media/network_error.18eaafc4.png";